/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createEnqueueBackfillChargerMakesAndModelsResultFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type EnqueueBackfillChargerMakesAndModelsResult, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /backfills/charger-makes-and-models
 */
export interface ChargerMakesAndModelsRequestBuilder extends BaseRequestBuilder<ChargerMakesAndModelsRequestBuilder> {
    /**
     * EnqueueBackfillChargerMakesAndModels
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<EnqueueBackfillChargerMakesAndModelsResult>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<EnqueueBackfillChargerMakesAndModelsResult | undefined>;
    /**
     * EnqueueBackfillChargerMakesAndModels
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ChargerMakesAndModelsRequestBuilderUriTemplate = "{+baseurl}/backfills/charger-makes-and-models";
/**
 * Metadata for all the requests in the request builder.
 */
export const ChargerMakesAndModelsRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ChargerMakesAndModelsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createEnqueueBackfillChargerMakesAndModelsResultFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
